export const THIS_BUILD: string | null = commitIn(typeof RALLY_BUILD === "undefined" ? "" : RALLY_BUILD);

declare const RALLY_BUILD: string | undefined;

export function commitIn(said: string | undefined): string | null {
  const sha = said?.trim() ?? "";
  return sha === "" ? null : sha;
}
